// Import Globals
import Vue from 'vue'
import Router from 'vue-router'
import Jump from 'jump.js'
import store from '../vuex/store'
import ga from 'vue-ga'

// Import the Pages
import routes from './routes'

Vue.use(Router)

const appRouter = new Router({
  mode: 'history',
  routes: routes
})

ga(appRouter, 'UA-971860-1')

appRouter.beforeEach((to, from, next) => {
  store.commit('toggleChanging')
  Jump('html', {
    duration: window.pageYOffset > 10 ? 500 : 0,
    callback: () => {
      next()
      store.commit('toggleChanging')
    }
  })
})

export default appRouter



// WEBPACK FOOTER //
// ./src/router/index.js